if (!customElements.get('variant-selects')) {
  customElements.define('variant-selects', class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('change', this.onVariantChange.bind(this));
    }

    onVariantChange(event) {
      const target = event.target;
      
      // Only handle option inputs (select or radio)
      if (!target.matches('select[name^="options"], input[name^="options"]')) {
        return;
      }

      this.updateVariantInput();
      this.updateVariantStatuses();
    }

    updateVariantInput() {
      const productForm = this.closest('product-form-component');
      if (!productForm) return;

      const form = productForm.querySelector('form');
      if (!form) return;

      const selectedOptions = this.getSelectedOptions();
      const variant = this.getVariantFromOptions(selectedOptions);

      const variantInput = form.querySelector('input[name="id"]');
      if (variantInput && variant) {
        variantInput.value = variant.id;
        variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      // Dispatch variant:change event for other components
      if (variant) {
        form.dispatchEvent(new CustomEvent('variant:change', {
          detail: { variant: variant },
          bubbles: true
        }));
      }
    }

    getSelectedOptions() {
      const options = [];
      
      // Get from SELECT elements
      this.querySelectorAll('select[name^="options"]').forEach(select => {
        if (select.value) options.push(select.value);
      });
      
      // Get from RADIO elements (checked only)
      this.querySelectorAll('input[type="radio"][name^="options"]:checked').forEach(radio => {
        if (radio.value) options.push(radio.value);
      });

      return options;
    }

    getVariantFromOptions(options) {
      const variantsData = this.getVariantsData();
      if (!variantsData || variantsData.length === 0) return null;

      return variantsData.find(variant => {
        return (
          String(variant.option1 || '') === String(options[0] || '') &&
          String(variant.option2 || '') === String(options[1] || '') &&
          String(variant.option3 || '') === String(options[2] || '')
        );
      }) || null;
    }

    getVariantsData() {
      // Try to get from data attribute
      const productForm = this.closest('product-form-component');
      if (productForm && productForm.dataset.variants) {
        try {
          return JSON.parse(productForm.dataset.variants);
        } catch (e) {}
      }

      // Try to get from script tag
      const variantScript = document.querySelector('[data-selected-variant], [data-variants-json]');
      if (variantScript) {
        try {
          const data = JSON.parse(variantScript.textContent);
          // If it's single variant object, try to find all variants from product data
          if (data.id) {
            // Look for full variants array
            const productInfo = this.closest('product-info');
            if (productInfo) {
              const allVariantsScript = productInfo.querySelector('script[type="application/ld+json"]');
              if (allVariantsScript) {
                const productData = JSON.parse(allVariantsScript.textContent);
                if (productData.offers && Array.isArray(productData.offers)) {
                  // Extract variants from structured data
                  return this.extractVariantsFromStructuredData(productData.offers);
                }
              }
            }
          }
          return Array.isArray(data) ? data : [];
        } catch (e) {}
      }

      return [];
    }

    extractVariantsFromStructuredData(offers) {
      // This is a fallback - ideally variants should be in data attribute
      // For now, return empty and rely on data-variants attribute
      return [];
    }

    updateVariantStatuses() {
      const selectedOptions = this.getSelectedOptions();
      const variants = this.getVariantsData();
      
      if (!variants || variants.length === 0) return;

      // Update availability for each option
      this.querySelectorAll('input[name^="options"], select[name^="options"]').forEach(input => {
        // This can be expanded to show/hide unavailable variants
        // For now, just basic functionality
      });
    }
  });
}
